<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5>
        Filtros
      </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col
          cols="12"
          md="3"
          class="mb-md-0 mb-2"
        >
          <label>Status</label>
          <v-select
            :value="statusFilter"
            :options="statusOptions"
            class="w-100"
            :reduce="val => val.value"
            @input="(val) => $emit('update:statusFilter', val)"
          />
        </b-col>
        <b-col
          v-if="statusFilter === 'baixado' || statusFilter === 'todos'"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Data Baixa Inicial</label>
          <b-input-group>
            <b-form-datepicker
              id="data_baixa_inicial"
              :value="dataBaixaInicialFilter"
              @input="(val) => $emit('update:dataBaixaInicialFilter', val)"
              placeholder="DD/MM/AAAA"
              :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
              locale="pt-BR"
              :value-as-date="false"
              reset-button
              close-button
              :label-help="'Use as teclas de seta para navegar pelas datas do calendário'"
              :label-no-date-selected="'Nenhuma data selecionada'"
              :label-calendar="'Calendário'"
              :label-nav-this-month="'Mês atual'"
              :label-nav-next-month="'Próximo mês'"
              :label-nav-prev-month="'Mês anterior'"
              :label-nav-next-year="'Próximo ano'"
              :label-nav-prev-year="'Ano anterior'"
              :label-nav-next-decade="'Próxima década'"
              :label-nav-prev-decade="'Década anterior'"
              :start-weekday="1"
            />
            <b-input-group-append>
              <b-button
                v-if="dataBaixaInicialFilter"
                variant="outline-secondary"
                size="sm"
                @click="$emit('update:dataBaixaInicialFilter', null)"
                title="Limpar data inicial"
              >
                <feather-icon
                  icon="XIcon"
                  size="14"
                />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>       
        <b-col
          v-if="statusFilter === 'baixado' || statusFilter === 'todos'"
          md="2"
          class="mb-md-0 mb-2"
        >
          <label>Data Baixa Final</label>
          <b-input-group>
            <b-form-datepicker
              id="data_baixa_final"
              :value="dataBaixaFinalFilter"
              @input="(val) => $emit('update:dataBaixaFinalFilter', val)"
              placeholder="DD/MM/AAAA"
              :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
              locale="pt-BR"
              :value-as-date="false"
              reset-button
              close-button
              :label-help="'Use as teclas de seta para navegar pelas datas do calendário'"
              :label-no-date-selected="'Nenhuma data selecionada'"
              :label-calendar="'Calendário'"
              :label-nav-this-month="'Mês atual'"
              :label-nav-next-month="'Próximo mês'"
              :label-nav-prev-month="'Mês anterior'"
              :label-nav-next-year="'Próximo ano'"
              :label-nav-prev-year="'Ano anterior'"
              :label-nav-next-decade="'Próxima década'"
              :label-nav-prev-decade="'Década anterior'"
              :start-weekday="1"
            />
            <b-input-group-append>
              <b-button
                v-if="dataBaixaFinalFilter"
                variant="outline-secondary"
                size="sm"
                @click="$emit('update:dataBaixaFinalFilter', null)"
                title="Limpar data final"
              >
                <feather-icon
                  icon="XIcon"
                  size="14"
                />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>        
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BRow, BCol, BFormInput, BFormDatepicker, BInputGroup, BInputGroupAppend, BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormInput,
    BFormDatepicker,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    vSelect,
  },
  props: {
    statusFilter: {
      type: [String, null],
      default: 'ativo',
    },
    statusOptions: {
      type: Array,
      required: true,
    },
    dataBaixaInicialFilter: {
      type: [String, null],
      default: null,
    },
    dataBaixaFinalFilter: {
      type: [String, null],
      default: null,
    },
  },
  watch: {
    dataBaixaInicialFilter() {
      this.validateDateRange()
    },
    dataBaixaFinalFilter() {
      this.validateDateRange()
    },
  },
  methods: {
    validateDateRange() {
      if (this.dataBaixaInicialFilter && this.dataBaixaFinalFilter) {
        const startDate = new Date(this.dataBaixaInicialFilter)
        const endDate = new Date(this.dataBaixaFinalFilter)
        
        if (startDate > endDate) {
          this.$toast({
            component: 'ToastificationContent',
            props: {
              title: 'Erro de validação',
              icon: 'AlertTriangleIcon',
              variant: 'warning',
              text: 'Data inicial deve ser menor que data final',
            },
          })
        }
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
